import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AutomaticStringCreationComponent } from '../automatic-string-creation/automatic-string-creation.component';

@Component({
  selector: 'app-auto-batch-serial-creation',
  templateUrl: './automatic-batch-creation.component.html',
  styleUrls: ['./automatic-batch-creation.component.css']
})
export class AutomaticBatchCreationComponent {

  constructor(public dialog: MatDialog){

  }

  openDialog1(): void {
      this.dialog.open(AutomaticStringCreationComponent, {
    }); 
  }

}

